import { render, staticRenderFns } from "./MailingResource.vue?vue&type=template&id=4441f620&scoped=true&"
import script from "./MailingResource.vue?vue&type=script&lang=js&"
export * from "./MailingResource.vue?vue&type=script&lang=js&"
import style0 from "./MailingResource.vue?vue&type=style&index=0&id=4441f620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441f620",
  null
  
)

export default component.exports